export const SitesnApsConfigData = {
    "maxLineLimit": 25001,
    "maxFileSize": 10,
    "headerMismatchErrorMsg": "Specified headers dont match",
    "maxRowsErrorMsg": "Max number of rows allowed is ",
    "existingSitenameErrorSites": "existingSitenameErrorSites",
    "matchFileType": true,
    "checkDataType": true,
    "matchHeader": true,
    "rowMisMatchError": "Error on row",
    "knownObj": [
        {
            "headerName": "SiteName",
            "headerType": "string",
            "maxLength": 32,
            "validateRegex": true
        },
        {
            "headerName": "timeZone",
            "headerType": "string",
            "validateRegex": false
        },
        {
            "headerName": "scheduledReportTime",
            "headerType": "string",
            "validateRegex": false
        },
        {
            "headerName": "EmailSubscribed",
            "headerType": "boolean",
            "validateRegex": false
        },
        {
            "headerName": "emailList",
            "headerType": "string",
            "validateRegex": false
        },
        {
            "headerName": "BSSID",
            "headerType": "string",
            "maxLength": 32
        },
        {
            "headerName": "AssetName",
            "headerType": "string",
            "maxLength": 32
        },
        {
            "headerName": "LocationFriendlyName",
            "headerType": "string",
            "maxLength": 32
        }
    ]
}
